import {Placeholder} from "@/components/placeholder";
import React from "react";
import ThemeLink from "@/components/link";


function Logo() {
    return <div className="s-flex select-none flex-shrink-0">
        <ThemeLink href={"/"}>
            <div className="s-flex">
                <Placeholder src="/site/logo2.jpg" imageHeight={60} imageWidth={200}/>
                {/*<div className="c-flex flex-col text-logo font-bold">*/}
                {/*    <h1 className="text-left text-[30px]">{process.env.NEXT_PUBLIC_COMPANY_NAME}</h1>*/}
                {/*    <span className="text-[23px] -mt-3">COUPLING</span>*/}
                {/*</div>*/}
            </div>
        </ThemeLink>
        <div className="h-[55px] w-[1px] bg-[#dfdfdf] mx-2"></div>
        <div className="text-themeP">
            <p>FA自动化零配件</p>
            <p>一站式采购平台</p>
        </div>
    </div>;
}

export default React.memo(Logo);
